import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "ui-field mb-5" }
const _hoisted_2 = {
  key: 0,
  class: "ui-empty"
}
const _hoisted_3 = {
  key: 1,
  class: "space-y-3"
}
const _hoisted_4 = {
  key: 0,
  class: "module-list"
}
const _hoisted_5 = ["title"]
const _hoisted_6 = { class: "module-name" }
const _hoisted_7 = { class: "module-hint" }
const _hoisted_8 = { class: "catalog-summary" }
const _hoisted_9 = { class: "module-name" }
const _hoisted_10 = ["title"]
const _hoisted_11 = { class: "module-list catalog-module-children" }
const _hoisted_12 = ["title"]
const _hoisted_13 = { class: "module-name" }
const _hoisted_14 = { class: "module-hint" }

import { Card, CardHeader, CardTitle, CardContent } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { Hint } from '@/components/ui/hint';
import { Input } from '@/components/ui/input';

import { computed, ref } from 'vue';

interface Props {
  modules: CatalogModule[];
}


export default /*@__PURE__*/_defineComponent({
  __name: 'ProductModulesTree',
  props: {
    modules: {}
  },
  setup(__props: any) {

const props = __props;

const search = ref('');

const filteredModules = computed(() => {
  const query = search.value.trim().toLowerCase();
  if (!query) {
    return props.modules;
  }

  return props.modules.reduce((acc: CatalogModule[], rootModule) => {
    const rootMatches = rootModule.name.toLowerCase().includes(query);
    const matchingChildren = rootModule.children.filter((childModule) =>
      childModule.name.toLowerCase().includes(query)
    );

    if (!rootMatches && matchingChildren.length === 0) {
      return acc;
    }

    acc.push({
      ...rootModule,
      children: rootMatches ? rootModule.children : matchingChildren,
    });
    return acc;
  }, []);
});

const groupModules = computed(() =>
  filteredModules.value.filter((module) => module.children.length > 0)
);
const leafModules = computed(() =>
  filteredModules.value.filter((module) => module.children.length === 0)
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Card), { class: "modules-card" }, {
    default: _withCtx(() => [
      _createVNode(_unref(CardHeader), { class: "flex flex-row items-center justify-between gap-3" }, {
        default: _withCtx(() => [
          _createVNode(_unref(CardTitle), null, {
            default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
              _createTextVNode("Модули продукта", -1)
            ]))]),
            _: 1
          }),
          _createVNode(_unref(Badge), { variant: "secondary" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(filteredModules.value.length) + " разделов", 1)
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_unref(CardContent), null, {
        default: _withCtx(() => [
          _createElementVNode("label", _hoisted_1, [
            _cache[2] || (_cache[2] = _createElementVNode("span", { class: "ui-label" }, "Поиск по названию модуля", -1)),
            _createVNode(_unref(Input), {
              modelValue: search.value,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((search).value = $event)),
              type: "search",
              placeholder: "Название модуля"
            }, null, 8, ["modelValue"])
          ]),
          (filteredModules.value.length === 0)
            ? (_openBlock(), _createElementBlock("p", _hoisted_2, _toDisplayString(search.value ? 'Модули по запросу не найдены' : 'У продукта нет модулей'), 1))
            : (_openBlock(), _createElementBlock("div", _hoisted_3, [
                (leafModules.value.length)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(leafModules.value, (module) => {
                        return (_openBlock(), _createElementBlock("article", {
                          key: module.id,
                          class: "catalog-module-line"
                        }, [
                          _createElementVNode("span", {
                            class: _normalizeClass(["mark", { 'mark-paid': module.is_paid }]),
                            title: module.is_paid ? 'Платный' : undefined
                          }, [
                            (module.is_paid)
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                  _createTextVNode("₽")
                                ], 64))
                              : _createCommentVNode("", true)
                          ], 10, _hoisted_5),
                          _createElementVNode("strong", _hoisted_6, _toDisplayString(module.name), 1),
                          _createElementVNode("span", _hoisted_7, [
                            (module.description)
                              ? (_openBlock(), _createBlock(_unref(Hint), {
                                  key: 0,
                                  label: "Описание"
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(module.description), 1)
                                  ]),
                                  _: 2
                                }, 1024))
                              : _createCommentVNode("", true)
                          ])
                        ]))
                      }), 128))
                    ]))
                  : _createCommentVNode("", true),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(groupModules.value, (rootModule) => {
                  return (_openBlock(), _createElementBlock("details", {
                    key: rootModule.id,
                    class: "module-group-panel"
                  }, [
                    _createElementVNode("summary", _hoisted_8, [
                      _createElementVNode("span", _hoisted_9, _toDisplayString(rootModule.name), 1),
                      _createElementVNode("span", {
                        class: _normalizeClass(["mark", { 'mark-paid': rootModule.is_paid }]),
                        title: rootModule.is_paid ? 'Платный' : undefined
                      }, [
                        (rootModule.is_paid)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              _createTextVNode("₽")
                            ], 64))
                          : _createCommentVNode("", true)
                      ], 10, _hoisted_10),
                      _createVNode(_unref(Badge), {
                        variant: "outline",
                        class: "num"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(rootModule.children.length), 1)
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    _createElementVNode("div", _hoisted_11, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(rootModule.children, (childModule) => {
                        return (_openBlock(), _createElementBlock("article", {
                          key: childModule.id,
                          class: "catalog-module-line"
                        }, [
                          _createElementVNode("span", {
                            class: _normalizeClass(["mark", { 'mark-paid': childModule.is_paid }]),
                            title: childModule.is_paid ? 'Платный' : undefined
                          }, [
                            (childModule.is_paid)
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                  _createTextVNode("₽")
                                ], 64))
                              : _createCommentVNode("", true)
                          ], 10, _hoisted_12),
                          _createElementVNode("strong", _hoisted_13, _toDisplayString(childModule.name), 1),
                          _createElementVNode("span", _hoisted_14, [
                            (childModule.description)
                              ? (_openBlock(), _createBlock(_unref(Hint), {
                                  key: 0,
                                  label: "Описание"
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(childModule.description), 1)
                                  ]),
                                  _: 2
                                }, 1024))
                              : _createCommentVNode("", true)
                          ])
                        ]))
                      }), 128))
                    ])
                  ]))
                }), 128))
              ]))
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})